<Button
    @click="handler($event, type, id)"
    :label="`
            <i class='icon ${type}'></i> ${value}`"
    :attributes="{class:['btn-sm', classValue]}"
    :disabled="isDisabled"
/>
